import {
  createContext,
  type ForwardedRef,
  type RefObject,
  type Context,
} from 'react';

import type { Point } from '../types/point.js';

export type OverlaysContextProps = {
  mousePosition?: Point;
  eventLocalPoint?: Point;
  chartBounds?: DOMRect;
  isInChartBounds: boolean;
  tooltipContainerRef?: ForwardedRef<HTMLDivElement>;
  overlayRef?: RefObject<SVGRectElement | HTMLDivElement>;
};

export const OverlaysContext: Context<OverlaysContextProps> =
  createContext<OverlaysContextProps>({
    isInChartBounds: false,
  });
